import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useFormik } from "formik";
import { contactSchema } from "helpers/yup_validator";
import { useContactUsFormMutation } from "store/services/user.service";
import toast from "react-hot-toast";

const ContactForm = () => {
  const [contactUsForm] = useContactUsFormMutation();

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    },
    validationSchema: contactSchema,
    onSubmit: async (values) => {
      try {
        await contactUsForm(values).unwrap();
        toast.success("Message sent successfully");
        formik.resetForm();
      } catch (error) {
        console.error("Failed to send message:", error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Row>
        <Col md="6" className="my-2">
          <label htmlFor="firstName" className="form-label m-0">
            First Name
          </label>
          <input
            id="firstName"
            name="firstName"
            type="text"
            className="form-control px-0 rounded-0 border-0 pt-0"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.firstName}
          />
          {formik.touched.firstName && formik.errors.firstName ? (
            <div class="error-valid">{formik.errors.firstName}</div>
          ) : null}
        </Col>
        <Col md="6" className="my-2">
          <label htmlFor="lastName" className="form-label m-0">
            Last Name
          </label>
          <input
            id="lastName"
            name="lastName"
            type="text"
            className="form-control px-0 rounded-0 border-0 pt-0"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.lastName}
          />
          {formik.touched.lastName && formik.errors.lastName ? (
            <div class="error-valid">{formik.errors.lastName}</div>
          ) : null}
        </Col>
        <Col md="6" className="my-2">
          <label htmlFor="email" className="form-label m-0">
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            className="form-control px-0 rounded-0 border-0 pt-0"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
          />
          {formik.touched.email && formik.errors.email ? (
            <div class="error-valid">{formik.errors.email}</div>
          ) : null}
        </Col>
        <Col md="6" className="my-2">
          <label htmlFor="phone" className="form-label m-0">
            Phone Number
          </label>
          <input
            id="phone"
            name="phone"
            type="tel"
            className="form-control px-0 rounded-0 border-0 pt-0"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.phone}
          />
          {formik.touched.phone && formik.errors.phone ? (
            <div class="error-valid">{formik.errors.phone}</div>
          ) : null}
        </Col>
        <Col lg="12" className="my-2 py-3">
          <h6 className="m-0 fw-sbold">Select Subject?</h6>
          <ul className="list-unstyled ps-0 mt-3 mb-0 d-flex align-items-center gap-10 flex-wrap radioList">
            <li className="px-2">
              <div className="d-flex align-items-center">
                <input
                  id="generalInquiry"
                  type="radio"
                  name="subject"
                  value="General Inquiry"
                  className="form-check me-2"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.subject === "General Inquiry"}
                />
                <label className="form-label m-0" htmlFor="generalInquiry">
                  General Inquiry
                </label>
              </div>
            </li>
            <li className="px-2">
              <div className="d-flex align-items-center">
                <input
                  id="support"
                  type="radio"
                  name="subject"
                  value="Support"
                  className="form-check me-2"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.subject === "Support"}
                />
                <label className="form-label m-0" htmlFor="support">
                  Support
                </label>
              </div>
            </li>
            <li className="px-2">
              <div className="d-flex align-items-center">
                <input
                  id="feedback"
                  type="radio"
                  name="subject"
                  value="Feedback"
                  className="form-check me-2"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.subject === "Feedback"}
                />
                <label className="form-label m-0" htmlFor="feedback">
                  Feedback
                </label>
              </div>
            </li>
          </ul>
          {formik.touched.subject && formik.errors.subject ? (
            <div class="error-valid">{formik.errors.subject}</div>
          ) : null}
        </Col>
        <Col md="12" className="my-2">
          <label htmlFor="message" className="form-label m-0">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            rows="1"
            placeholder="Write your message.."
            className="form-control px-0 rounded-0 border-0 pt-0"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.message}
          />
          {formik.touched.message && formik.errors.message ? (
            <div class="error-valid">{formik.errors.message}</div>
          ) : null}
        </Col>
        <Col lg="12" className="my-2 btnWrp pt-4 text-end">
          <Button
            type="submit"
            className="d-inline-flex align-items-center justify-content-center commonBtn"
          >
            Send Message
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ContactForm;
